
import React from 'react';
import { motion } from 'framer-motion';

function WhyMarketing() {
    const fadeInSide = (direction) => ({
        hidden: { x: direction === 'left' ? -50 : 50, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3 }
        }
    };

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="mt-20 px-6 lg:px-20 max-w-7xl mx-auto overflow-hidden mb-10"
        >
            <motion.h1
                variants={fadeInSide('left')}
                className="text-center text-5xl md:text-8xl font-bold text-primary tracking-tight"
            >
                Why <span className='text-secondary relative'>Marketing?
                    <motion.span
                        initial={{ width: 0 }}
                        whileInView={{ width: '100%' }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        className="absolute bottom-0 left-0 h-2 bg-secondary/30 -z-10"
                    ></motion.span>
                </span>
            </motion.h1>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-12 mt-16">

                {/* Lottie Animation Side */}
                <motion.div
                    variants={fadeInSide('left')}
                    className="w-full lg:w-1/2 flex justify-center relative"
                >
                    {/* Decorative Ring behind Lottie */}
                    <div className="absolute inset-0 bg-primary/5 rounded-full blur-3xl scale-75 animate-pulse"></div>

                    <dotlottie-wc
                        src="https://lottie.host/3f30ed51-a345-46ed-878d-ef3d752b02f9/TV9SlX5nKX.lottie"
                        className="w-[300px] h-[300px] md:w-[500px] md:h-[500px] z-10"
                        background="transparent"
                        speed="1"
                        autoplay
                        loop
                    ></dotlottie-wc>
                </motion.div>

                {/* Content Side */}
                <motion.div
                    variants={containerVariants}
                    className="w-full lg:w-1/2 space-y-8"
                >
                    <motion.p
                        variants={fadeInSide('right')}
                        className="text-gray-600 text-lg md:text-2xl leading-relaxed border-l-4 border-secondary pl-6"
                    >
                        We offer a comprehensive suite of digital marketing services designed to help your business <span className="font-bold text-primary">thrive</span> in the online world.
                        Our team focuses on data-driven strategies that contribute to measurable growth.
                    </motion.p>
                    <motion.div variants={fadeInSide('right')}>
                        <h2 className="text-3xl md:text-4xl font-semibold text-primary leading-tight">
                            The answer to all these questions lie in <b className='text-secondary italic'>Marketing!</b>
                        </h2>
                    </motion.div>
                    <motion.p
                        variants={fadeInSide('right')}
                        className='text-gray-600 text-lg md:text-xl leading-relaxed bg-primary/5 p-6 rounded-2xl shadow-inner'
                    >
                        In today's digital age, marketing is the key to unlocking business success.
                        By investing in marketing, you're not just promoting products; you're
                        <span className="text-primary font-medium"> building relationships</span>, fostering loyalty, and creating a strong foundation for long-term growth.
                    </motion.p>
                    <motion.div
                        whileHover={{ scale: 1.02 }}
                        className="h-1 w-24 bg-secondary rounded-full"
                    ></motion.div>
                </motion.div>
            </div>
        </motion.div>
    )
}

export default WhyMarketing;